import { Picker, Popup } from 'vant';

import dayjs from 'dayjs';
import moment from 'moment';

export default {
  name: 'CallMobileDateTime',
  components: {
    Popup,
    Picker
  },
  props: {
    time: {
      type: Date,
      default: new Date()
    }
  },
  data () {
    return {
      dataCurrentDate: new Date()
    };
  },
  mounted () {
    this.dataCurrentDate = this.time;
  },
  methods: {
    onConfirm (index, data) {
      const date = data[0].text; // Sat 08 Aug
      const hours = data[1].values || 0;
      const minutes = data[2].values || 0;

      const year = moment().year();
      const utcParse = moment(
        `${year} ${date} ${hours}:${minutes}`,
        'YYYY ddd DD MMM HH:mm'
      )
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss[Z]');

      this.$emit('on-date', new Date(utcParse));
    }
  },
  computed: {
    computedColumns () {
      const _day = new Date().getDate();
      return [
        {
          values: [...new Array(180)].map((item, index) => {
            index += _day;
            return {
              values: new Date(new Date().setDate(index)),
              text: dayjs(new Date(new Date().setDate(index))).format(
                'ddd DD MMM'
              )
            };
          }),
          defaultIndex: this.dataCurrentDate.getDate() - _day
        },
        {
          values: [...new Array(24)].map((item, index) => {
            return {
              values: index,
              text: (index > 9 ? index : '0' + index) + ' hour'
            };
          }),
          defaultIndex: this.dataCurrentDate.getHours()
        },
        {
          values: [...new Array(60)].map((item, index) => {
            return {
              values: index,
              text: (index > 9 ? index : '0' + index) + ' minutes'
            };
          }),
          defaultIndex: this.dataCurrentDate.getMinutes()
        }
      ];
    }
  },
  render (h) {
    return (
      <picker
        item-height={34}
        columns={this.computedColumns}
        onChange={(value, index) => this.onConfirm(value, index)}
      />
    );
  }
};
